import React, { useState, useEffect } from "react";
import { apiRequest, API_ENDPOINTS } from "../utils/api";

export default function Notifications() {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        loadNotifications();
    }, []);

    const loadNotifications = async () => {
        try {
            const data = await apiRequest(API_ENDPOINTS.NOTIFICATIONS);
            setNotifications(data);
        } catch (err) {
            console.error("Error loading notifications:", err);
            setError("Failed to load notifications");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="notifications-loading">Loading notifications...</div>;
    }

    if (error) {
        return <div className="notifications-error">{error}</div>;
    }

    if (notifications.length === 0) {
        return (
            <div className="notifications-empty">
                <p>No notifications at the moment.</p>
            </div>
        );
    }

    return (
        <div className="notifications-widget">
            <h3>📢 Latest Notifications</h3>
            <div className="notifications-list">
                {notifications.slice(0, 5).map(notification => (
                    <div key={notification.id} className="notification-item">
                        {notification.title && (
                            <h4 className="notification-title">{notification.title}</h4>
                        )}
                        <p className="notification-message">{notification.message}</p>
                        {notification.apartment_tag && (
                            <span className="notification-tag">#{notification.apartment_tag}</span>
                        )}
                        <small className="notification-date">
                            {new Date(notification.created_at).toLocaleString()}
                        </small>
                    </div>
                ))}
            </div>
        </div>
    );
}
